var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, HStack, Pressable, useTheme } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import Icon from "../../icons/Icon";
import Input from "./Input";
const SearchInput = (_a) => {
    var { placeholder, wrapperProps } = _a, rest = __rest(_a, ["placeholder", "wrapperProps"]);
    const { colors } = useTheme();
    const [value, setValue] = useState("");
    const { t } = useTranslation();
    const handleChange = (value) => {
        setValue(value);
    };
    const resetValue = () => setValue("");
    const placeholderDefault = t("search");
    return (_jsxs(HStack, Object.assign({ position: "relative" }, wrapperProps, { children: [_jsx(Input, Object.assign({ value: value, testID: "search-input", placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : placeholderDefault, leftIconName: "search", maxW: 250, onChange: handleChange }, rest)), value !== "" ? (_jsx(Pressable, Object.assign({ onPress: resetValue, mr: 1.5, position: "absolute", right: 0, top: 0.5 }, { children: _jsx(Box, Object.assign({ p: 2 }, { children: _jsx(Icon, { name: "close", size: 16, fill: colors.gray[800] }) })) }))) : undefined] })));
};
export default SearchInput;
